<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc01"></a>
<a id="page_vii"></a>
<h2 class="chaptertitle" id="p_1">Contents</h2>
<p class="toc" id="p_2"><a href="#/acknowledgments">Acknowledgments</a></p>
<p class="toc" id="p_3"><a href="#/introduction">Introduction: Catholic Social Doctrine and Political Philosophy</a></p>
<p class="toc" id="p_4"><a href="#/part01"><i>Part One The Human Person, the Political Community, and the Common Good</i></a></p>
<p class="toc1" id="p_5"><a href="#/chapter01">1. The Dignity of the Human Person, Human Rights, and Natural Law</a></p>
<p class="toc1" id="p_6"><span href="#/chapter02" title="Link target outside of Sample">2. The Meaning of the Common Good</span></p>
<p class="toc1" id="p_7"><span href="#/chapter03" title="Link target outside of Sample">3. Seeking the Common Good through Virtue and Grace</span></p>
<p class="toc1" id="p_8"><span href="#/chapter04" title="Link target outside of Sample">4. Seeking the Common Good through Justice and Social Justice</span></p>
<p class="toc1" id="p_9"><span href="#/chapter05" title="Link target outside of Sample">5. Seeking the Common Good through Law and Public Policy: Same-Sex Marriage, the Life Questions, and Biotechnology</span></p>
<p class="toc" id="p_10"><span href="#/part02" title="Link target outside of Sample"><i>Part Two Civil Society and the Common Good: Three Mediating Institutions</i></span></p>
<p class="toc1" id="p_11"><span href="#/chapter06" title="Link target outside of Sample">6. Civil Society and the Church</span></p>
<p class="toc1" id="p_12"><span href="#/chapter07" title="Link target outside of Sample">7. Civil Society, the Family, and the Principle of Subsidiarity</span></p>
<p class="toc1" id="p_13"><span href="#/chapter08" title="Link target outside of Sample">8. Civil Society, the Catholic University, and Liberal Education</span></p>
<p class="toc" id="p_14"><span href="#/part03" title="Link target outside of Sample"><i>Part Three Private Property and the Universal Destination of Goods</i></span></p>
<p class="toc1" id="p_15"><span href="#/chapter09" title="Link target outside of Sample">9. The Economy, Work, Poverty, and Immigration</span></p>
<p class="toc1" id="p_16"><span href="#/chapter10" title="Link target outside of Sample">10. Safeguarding and Sustaining the Environment</span></p>
<a id="page_viii"></a>
<p class="toc" id="p_17"><span href="#/part04" title="Link target outside of Sample"><i>Part Four The International Community and Justice</i></span></p>
<p class="toc1" id="p_18"><span href="#/chapter11" title="Link target outside of Sample">11. The International Community</span></p>
<p class="toc1" id="p_19"><span href="#/chapter12" title="Link target outside of Sample">12. Just-War Principles</span></p>
<p class="toc" id="p_20"><span href="#/conclusion" title="Link target outside of Sample">Conclusion: The Tension between Catholic Social Doctrine and the Proponents of Religion as a Private Affair</span></p>
<p class="toc" id="p_21"><span href="#/appendix" title="Link target outside of Sample">Appendix: Pope Benedict XVI's <i>Caritas in veritate</i></span></p>
<p class="toc" id="p_22"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1" id="p_23"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?74be6310